// extracted by mini-css-extract-plugin
export default {"notice":"UDVAppAdvocacyBanner--notice--877c3b"};